import { Link } from "react-router-dom";
import { HardHat } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <HardHat size={24} weight="bold" className="text-orange-500" />
              <span className="text-lg font-bold tracking-tight">SCAFFOINDIA</span>
            </div>
            <p className="text-neutral-400 text-sm max-w-xs leading-relaxed">
              India&apos;s leading scaffolding RFQ platform connecting buyers with verified suppliers across major cities.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-neutral-300 mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="text-sm text-neutral-400 hover:text-white transition-colors"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-neutral-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-neutral-300 mb-4">Platform</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about-us"
                  className="text-sm text-neutral-400 hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact-us"
                  className="text-sm text-neutral-400 hover:text-white transition-colors"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/suppliers"
                  className="text-sm text-neutral-400 hover:text-white transition-colors"
                >
                  Our Suppliers
                </Link>
              </li>
              <li>
                <Link
                  to="/materials"
                  className="text-sm text-neutral-400 hover:text-white transition-colors"
                >
                  Browse Materials
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-neutral-800 text-neutral-500 text-xs font-mono">
          &copy; {new Date().getFullYear()} Scaffoindia. All rights reserved.
        </div>
      </div>
    </footer>
  );
}